import React from 'react';
import { Breadcrumb } from 'antd';
import Heading from './Heading';

/**
 * Reusable page header with breadcrumb, title, description, and optional action items.
 * @param {Object} props
 * @param {Array<string>} props.breadcrumb - Breadcrumb items
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {React.ReactNode} [props.actions] - Optional action items (buttons, etc.)
 * @param {string} [props.className] - Optional extra className
 * @param {Object} [props.style] - Optional style overrides
 */

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth <= 600);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

const PageHeader = ({ breadcrumb = [], title, description, actions, className = '', style = {} }) => {
  const isMobile = useIsMobile();
  return (
    <div
      className={`breadcrumb-title-block ${className}`.trim()}
      style={{
        marginBottom: 32,
        backgroundColor: 'transparent',
        ...style,
      }}
    >
      {breadcrumb.length > 0 && (
        <Breadcrumb separator=">" style={{ fontSize: 15, color: '#6B7A5B', fontWeight: 500, background: 'none', marginBottom: 32 }}>
          {breadcrumb.map((item, idx) => (
            <Breadcrumb.Item key={idx}>{item}</Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
      {!isMobile ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'nowrap' }}>
          <Heading content={title} />
          {actions && <div style={{ minWidth: 120, marginLeft: 24, display: 'flex', alignItems: 'center' }}>{actions}</div>}
        </div>
      ) : (
        <>
          <Heading content={title} />
        </>
      )}
      {description && (
        <p style={{ margin: '16px 0 0 0', fontSize: 16, color: '#000000', lineHeight: 1.5 }}>{description}</p>
      )}
      {isMobile && actions && (
        <div style={{ marginTop: 18, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>{actions}</div>
      )}
    </div>
  );
};

export default PageHeader;
